import { PageLink } from '../../../../../../assets/layout/core'

export const breadcrumbUpdate: PageLink[] = [
  {
    title: 'Serviços',
    path: '/commercial/tutorials',
    isSeparator: false,
    isActive: false
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false
  }
]
